// src/components/viewer/RecommendationBox.jsx

import React from 'react';

const RecommendationBox = ({ data }) => {
    const getRecommendationClass = () => {
        if (data.recommendation === 'FULL_APPROVAL') return 'full-approval';
        if (data.recommendation === 'REJECT') return 'reject';
        return 'partial-approval';
    };

    const eligibleUsers = data.eligibleUsers || [];
    const ineligibleUsers = data.ineligibleUsers || [];

    return (
        <div className={`recommendation-box ${getRecommendationClass()}`}>
            <h2>{data.recommendationText || data.recommendation || 'PENDING'}</h2>
            
            <div className="user-list">
                <strong>✅ Eligible Users ({eligibleUsers.length}):</strong>
                <span>{eligibleUsers.length > 0 ? eligibleUsers.join(', ') : 'None'}</span>
            </div>
            
            {ineligibleUsers.length > 0 && (
                <div className="user-list">
                    <strong>❌ Not Eligible ({ineligibleUsers.length}):</strong>
                    <span>{ineligibleUsers.join(', ')}</span>
                </div>
            )}
        </div>
    );
};

export default RecommendationBox;